import type { TriggerExecutionMode } from "@app/types/assistant/triggers";
import { TRIGGER_EXECUTION_MODES } from "@app/types/assistant/triggers";

// Les membres de l'app ne paient pas de crédits : ils consomment des tokens dont le coût se lit dans
// le Monitoring de l'app (remarque de Louka du 01/10). Le chat n'affiche aucun crédit : ni le coût
// d'un message, ni la bannière de limite. Un seul interrupteur pour toutes ces surfaces.
export const CREDITS_VISIBLES = false;

export function afficherCoutEnCredits(costCredits: number | null): boolean {
  return CREDITS_VISIBLES && costCredits !== null && costCredits > 0;
}

export function afficherLimiteDeCredits({
  procheDeLaLimite,
  bloque,
}: {
  procheDeLaLimite: boolean;
  bloque: boolean;
}): boolean {
  return CREDITS_VISIBLES && (procheDeLaLimite || bloque);
}

// Feuille d'une tache planifiee (02/10) : le choix de la reserve de credits est masque. Le mode du
// formulaire (par defaut « user_pool ») est garde s'il est permis ; sinon le premier mode permis le
// remplace, faute de quoi le serveur refuserait l'enregistrement. null : aucun mode permis.
export function modeDeFacturationPermis(
  valeur: TriggerExecutionMode,
  estPermis: (mode: TriggerExecutionMode) => boolean
): TriggerExecutionMode | null {
  if (estPermis(valeur)) {
    return valeur;
  }
  return TRIGGER_EXECUTION_MODES.find((mode) => estPermis(mode)) ?? null;
}
